module.exports = __webpack_public_path__ + "img/footerlogowhite_v2.511df19a.png";